import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import DivContainer from '../../components/DivContainer';
import Card from 'react-bootstrap/Card';
import DataTableLazy from '../../components/DataTableLazy';
import UserTransportService from '../../services/UserTransportService';
import Constants from '../../utils/constants';
import StringUtils from '../../utils/StringUtils';

class UserTransportDetailsDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new UserTransportService());
        this.state = {
            element: this.props.element,
            date: this.props.date,
            closable: true,
            userTransportPageable: undefined,
        };
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    initBeforeSetElement() {
        this.service.getDetailsList(this.getUserTransportCleanSearchCriteria()).then((data) => {
            this.setState({
                userTransportPageable: data,
            });
        });
    }
    renderFooter() {
        const footerItems = this.prepareFooterItems();
        if (footerItems !== undefined && footerItems.length > 0 && footerItems.filter((f) => f.rendered !== false)?.length > 0) {
            return (
                <React.Fragment>
                    <hr className='line-footer-user-dialog' />
                    {this.prepareFooter(footerItems)}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    prepareFooterItems() {
        return [];
    }

    renderHeader() {
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{t('userTransport.detail')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    getUserTransportCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            name: '',
            firstResult: 0,
            maxResults: 5,
            sortField: 'id',
            transportName: null,
            date: this.props.date,
            userName:null,
            userId: this.state.element.id,
            transportId: this.state.element.transportId,
            sortAsc: false,
        };
    }
    getDetailsList(criteria) {
        this.service
            .getDetailsList(criteria)
            .then((data) => {
                this.setState({
                    userTransportPageable: data,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('global.fetch-error'));
            });
    }
    formatValue(rowData, obj) {
        if (StringUtils.isBlank(rowData[obj.field])) {
            return 0;
        }
        return rowData[obj.field];
    }
    enumTemplate(field, rowData) {
        if (StringUtils.isBlank(rowData[field])) {
            return '';
        }
        return this.translate(`${field}.${rowData[field]}`);
    }
    renderDetails() {
        return (
            <Card>
                <DataTableLazy
                    id='details-table'
                    rendered={true}
                    dataPageable={this.state.userTransportPageable}
                    rows={5}
                    filterDisplay={'menu'}
                    selectionMode={undefined}
                    loadLazyData={(criteria) => this.service.getDetailsList(criteria)}
                    onSelect={() => {}}
                    rowsPerPageOptions={[]}
                    initialCriteria={this.getUserTransportCleanSearchCriteria()}
                    columns={[
                        {
                            field: 'startTravelDate',
                            header: t('user-summary-list.start-date'),
                            body: this.dateTemplate.bind(this, 'startTravelDate', Constants.DATE_TIME_FORMAT),
                            minWidth: '200px',
                        },
                        {
                            field: 'finishTravelDate',
                            header: t('user-summary-list.end-date'),
                            body: this.dateTemplate.bind(this, 'finishTravelDate', Constants.DATE_TIME_FORMAT),
                            minWidth: '200px',
                        },
                        {
                            field: 'burnedCalories',
                            header: t('user-summary-list.burned'),
                            float: 'right',
                            body: this.formatValue,
                        },
                        {
                            field: 'savedCo2Gram',
                            header: (
                                <span>
                                    {t('user-summary-list.saved')} CO<sub>2</sub>
                                </span>
                            ),
                            float: 'right',
                            body: this.formatValue,
                        },
                        {
                            field: 'totalDistanceTraveledInKilometers',
                            header: t('user-summary-list.traveled'),
                            float: 'right',
                            body: this.formatValue,
                        },
                        {
                            field: 'workDistance',
                            header: t('user-summary-list.declared'),
                            float: 'right',
                            body: this.formatValue,
                        },
                        {field: 'direction', header: t('user-summary-list.direction'), body: this.enumTemplate.bind(this, 'direction')},
                    ]}
                />
            </Card>
        );
    }
}

UserTransportDetailsDialog.defaultProps = {
    currentUser: undefined,
    visible: false,
    stationId: undefined,
    changePackageUrl: '/change-package',
};

UserTransportDetailsDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    changePackageUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
};

export default withTranslation()(UserTransportDetailsDialog);
